'use strict';Object.defineProperty(exports,'__esModule',{value:true});exports.getVersionString = getVersionString;var VERSION='2.9.2';function getVersionString(){return VERSION;}
//# sourceMappingURL=Version.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/dashjs/build/es5/src/core/Version.js
// module id = RR/r
// module chunks = 0